export const HELP_TABS = {
  HELP: 'HELP',
  QUICK_START: 'QUICK_START',
};
